import {Component, OnInit} from '@angular/core';
import {SessionStorageService} from '@services/session-storage.service';
import {storageKey} from '@constants/storage.constants';
import {NgIf} from '@angular/common';

@Component({
  selector: 'app-verification-complete',
  imports: [
    NgIf
  ],
  templateUrl: './verification-complete.component.html',
  styleUrl: './verification-complete.component.scss'
})
export class VerificationCompleteComponent implements OnInit {

  showCloseMessage = true;

  constructor(
    private storage: SessionStorageService,
  ) {
  }

  ngOnInit(): void {
    this.storage.remove(storageKey.token);
    this.storage.remove(storageKey.tokenType);
  }
}
